import * as React from 'react';
import { SearchFiltersTranslation } from '../constants';
import { FilterConfigurationProps, FilterField } from './types';
import { FilterPanelMenu } from './filter-panel-menu';
import { typeMapping } from './filter-configuration';
import { getCategoryId } from 'app/area/search-filters/filters/category-id';

interface FilterItemFieldProps {
  id: string;
  field: FilterField;
  filterSettings: FilterConfigurationProps;

  translation: SearchFiltersTranslation;
  locale: string;

  onClear: () => void;
}

export const FilterItemField: React.FC<FilterItemFieldProps> = ({
  id, field, translation, locale, onClear, filterSettings: {
    values, onChange, onFilterValidationChange, filterValidation,
    menuValues, onChangeMenu, options, onLoadOptions, updateFilterValues
  } }) => {

  const FilterComponent = typeMapping[field.type].component;
  const menuOptions = typeMapping[field.type].menuOptions;
  const hasMenuOptions = !!menuOptions && Object.keys(menuOptions).length > 0;
  const defaultValues = {
    codetableId: values?.[field?.defaultValueParams?.codetableId],
    caseTypeId: values?.[field?.defaultValueParams?.caseTypeId],
    cleanValues: field?.defaultValueParams?.cleanValues
  };

  return <>
    {hasMenuOptions && <FilterPanelMenu
      id={id}
      options={menuOptions}
      values={menuValues[id]}
      onChange={onChangeMenu}
      onClear={onClear}
      translation={translation}
    />}
    <FilterComponent
      id={id}
      label={field.label}
      onChange={onChange}
      onFilterValidationChange={onFilterValidationChange}
      onLoadOptions={onLoadOptions}
      updateFilterValues={updateFilterValues}
      translation={translation}
      values={values?.[id]}
      filterValidation={filterValidation}
      options={options[id] && options[id].codes || field.options}
      optionsEndpoint={field.optionsEndpoint}
      optionsParams={field.optionsParams}
      categoryOptionsEndpoint={field.categoryOptionsEndpoint}
      categoryOptionsParams={field.categoryOptionsParams}
      categoryOptions={options?.[getCategoryId(id)]?.codes}
      isHierarchy={field.isHierarchy}
      fetchingOptions={options[id] && options[id].fetching || false}
      defaultValue={defaultValues}
      locale={locale}
    />
  </>;
};
